import { env } from './env'

// OEM / ホワイトラベル: custom auth host `{tenant}.auth.{base}` から base domain を取り出す。
// - custom domain の auth root `auth.{base}`（tenant 無し）→ base（issue #429）
// - LOCKED ドメイン（env.AUTH_DOMAIN 配下、例 *.auth.locked.jp / *.lvh.me）→ null
// - dev / localhost / それ以外 → null
// 設計: oem-whitelabel-final-design-2026-06-03.md §5.1。
export const customBaseDomainFromHost = (hostname: string): string | null => {
  // hostname 未取得（SSR や window.location が部分的にしか無い環境）なら custom domain 判定しない。
  if (!hostname) return null
  const lockedAuthDomain = env.AUTH_DOMAIN
  if (
    hostname === lockedAuthDomain ||
    hostname.endsWith(`.${lockedAuthDomain}`)
  ) {
    return null
  }
  // custom auth host は `{tenant}.auth.{base}` の単一ラベル tenant のみ受け付ける。
  // tenant 部にドットを含む病的ホスト（例 a.b.auth.acme.jp）は base を導出しない。
  // getSubdomain（getSubdomainForHost.ts）/ locked-api の single-label 強制と揃える。
  const marker = '.auth.'
  const index = hostname.indexOf(marker)
  if (index <= 0) {
    // custom domain の auth root（tenant 無しの `auth.{base}`）も同じ partner に属する。
    // ここで null を返すと pages/root の連れ戻し先が LOCKED ドメインになる（issue #429）。
    const rootPrefix = 'auth.'
    if (
      hostname.startsWith(rootPrefix) &&
      hostname.length > rootPrefix.length
    ) {
      return hostname.slice(rootPrefix.length)
    }
    return null
  }
  const tenant = hostname.slice(0, index)
  if (tenant.includes('.')) return null
  return hostname.slice(index + marker.length)
}
